import { render, staticRenderFns } from "./SetButton.vue?vue&type=template&id=d402c4d2&"
import script from "./SetButton.vue?vue&type=script&lang=js&"
export * from "./SetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports